<template lang="pug">
 
  v-row( justify='center' align='start' ).fill-height
    template( v-for='{imagen, nombre, descripcion} of Lineas_comerciales' )
      v-col(cols=12 md=4).px-3
        v-img(:src='imagen' cover height='250px')
        v-card(flat color= 'transparent')
          v-card-text.my-2
            h2.font-weight-bold.rojo--text.icono-international.pl-4.pt-3  {{nombre}}
        v-card(flat color= 'white').elevation-0.my-2
          v-card-text.py-0
            h3.body-2.font-weight-thin.black--text {{descripcion}}
        v-card-actions
          v-spacer
          v-btn.ma-2(  tile outlined color='red'  style='border: 3px solid'  @click="$vuetify.goTo('#contenido-lineas-comerciales')" :to='{name:"productos", params: {linea_comercial: nombre} }') 
            h3( style='text-transform: none!important').azul--text Ver más
          v-spacer

</template>
<script>
export default {

  data: () => ({
      activar_buscador: true,
      texto_buscador:'',
      filtro:'',
      texto_filtro:'',
      seleccionado: [],
    }),
  computed: {
    Lineas_comerciales() {
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.lineas_comerciales : []
    },
    Categorias() {
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.categorias : []
    },
    Marcas(){
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.marcas : []
    },
    Items(){
      let o = []
      this.Lineas_comerciales.map( i => o.push({name: i.nombre, to: {name: 'productos', params: {linea_comercial: i.nombre}}}))
      o = o.map( i=> ({...i, children: this.Categorias.filter( j => j.linea_comercial == i.name).map( c => ({ name: c.categoria,  to: {name: 'productos', params: {categoria: c.categoria, linea_comercial: i.name}}})) }) )
      return o
    }
  },
  components:{
    
  }
}
</script>